/*
 * Jira Ticket:
 * Created Date: Tue, 14th Apr 2020, 10:47:30 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import { parse as readCSVFile } from 'papaparse';

const readFile = file => {
  return new Promise((resolve, reject) => {
    readCSVFile(file, {
      delimiter: ',',
      complete: result => {
        if (result.errors.length > 0) return reject(result);
        resolve(result.data);
      },
    });
  });
};

export default readFile;
